<script setup lang="tsx">
import type { GlobalThemeOverrides } from 'naive-ui'
import { CopyOutline } from '@vicons/ionicons5'
import Cookies from 'js-cookie'
import clipBoard from 'vue-clipboard3'
import IconBookOpen from '~icons/icon-park-outline/book-open'
import IconGithub from '~icons/icon-park-outline/github'
import IconLogout from '~icons/icon-park-outline/logout'
import IconUser from '~icons/icon-park-outline/user'
import avatarImg from '@/assets/images/avatar.png'
import { getMembershipInformation, switchAccounts, switchAccountsBack } from '@/service/api/basic'

import { useAppStore, useAuthStore, useTabStore, useTrackerStore } from '@/store'
import { local } from '@/utils'
import { renderIcon } from '@/utils/icon'

const { toClipboard } = clipBoard()

// const appStore = useAppStore()
const tabStore = useTabStore()
const trackerStore = useTrackerStore()

const { userInfo, logout } = useAuthStore()
const router = useRouter()

const memberShipInfo = ref<User.Membercenter.MemberShipInfo>({})

async function getMembershipInformationFn() {
  try {
    const val = await getMembershipInformation()
    if (val.code === 1000) {
      memberShipInfo.value = val.data
    }
  }
  catch (error: any) {
    throw new Error(error)
  }
}
const changeAccountModel = ref(false)
const accountVal = ref('')

async function copyBtn(txt: any) {
  try {
    await toClipboard(txt)
    window.$message.success('复制成功')
  }
  catch (e) {
    window.$message.error('复制失败')
  }
}

const showDropdown = ref(false)
function renderCustomHeader() {
  return (
    <div class="p-12px mb-12px b-b-1px b-b-#E9E9E9">
      <div class="flex items-center">
        <router-link to="/accountCenter/accountSecurity" onClick={() => showDropdown.value = false}><img class="w-34px mr-20px b-rd-50%" src={avatarImg} alt="" /></router-link>
        <div class="">
          <div class="flex items-center mb-8px">
            <span class="mr-20px">会员名称</span>
            <div class="flex items-center">
              <span class="mr-8px font-bold">{memberShipInfo.value.username}</span>
              <n-icon class="text-#1664FF cursor-pointer" size="18" onClick={() => { copyBtn(memberShipInfo.value.username) }}>
                <CopyOutline />
              </n-icon>
            </div>
          </div>
          <div class="flex items-center">
            <span class="mr-20px">认证状态</span>
            {memberShipInfo.value.authStatus === null && <n-button v-track={{ public: true }} text color="#1664ff" onClick={() => { showDropdown.value = false; router.push('/accountCenter/realName') }}> &gt;&gt;去认证</n-button>}
            {memberShipInfo.value.authStatus === 0 && <n-button v-track={{ public: true }} text color="#1664ff" onClick={() => { showDropdown.value = false; router.push('/accountCenter/realName') }}> &gt;&gt;去认证</n-button>}
            {memberShipInfo.value.authStatus === 1 && <n-tag bordered={false} color={{ color: '#1664ff', textColor: '#E9FAF3' }}>认证中</n-tag>}
            {memberShipInfo.value.authStatus === 2 && <n-tag bordered={false} color={{ color: '#E9FAF3', textColor: '#16CF91' }}>已认证</n-tag>}
          </div>
        </div>
      </div>
    </div>
  )
}

const options = computed(() => {
  return [
    {
      key: 'header',
      type: 'render',
      render: renderCustomHeader,
    },
    {
      key: 'accountSecurity',
      // icon: () => h(IconUser),
      label: () => {
        return (
          <div class="text-center">
            安全设置
          </div>
        )
      },
    },
    {
      key: 'contact',
      label: () => {
        return (
          <div class="text-center">
            修改联系消息
          </div>
        )
      },
    },
    {
      key: 'subaccount',
      label: () => {
        return (
          <div class="text-center">
            添加子账号
          </div>
        )
      },
    },
    {
      key: 'order',
      label: () => {
        return (
          <div class="text-center">
            我的订单
          </div>
        )
      },
    },
    {
      show: userInfo?.isAdmin === 'Y' && memberShipInfo.value.isRoot === 'Y',
      label: () => {
        return (
          <div class="text-center">
            切回账号
          </div>
        )
      },
      key: 'changeBackAccount',
    },
    {
      show: userInfo?.isAdmin === 'Y',
      label: () => {
        return (
          <div class="text-center">
            切换账号
          </div>
        )
      },
      key: 'changeAccount',
    },
    {
      key: 'loginOut',
      label: () => {
        return (
          <div class="text-center">
            退出登录
          </div>
        )
      },
      // icon: () => h(IconLogout),
    },
  ]
})
function handleSelect(key: string | number) {
  if (key === 'loginOut') {
    window.$dialog?.info({
      title: '退出登录',
      content: '确定退出当前登录',
      positiveText: '确认',
      negativeText: '取消',
      onPositiveClick: () => {
        trackerStore.reportBySpecialDirectives('Account_Exit', '退出账号', { public: true })
        logout()
      },
    })
  }
  if (key === 'accountSecurity') {
    router.push('/accountCenter/accountSecurity').then(() => {
      trackerStore.reportBySpecialDirectives('Page_Jumpto', '安全设置', { public: true })
    })
  }
  if (key === 'contact') {
    router.push('/accountCenter/accountSecurity').then(() => {
      trackerStore.reportBySpecialDirectives('Page_Jumpto', '修改联系信息', { public: true })
    })
  }
  if (key === 'subaccount') {
    router.push('/accountCenter/subaccount').then(() => {
      trackerStore.reportBySpecialDirectives('Page_Jumpto', '添加子账号', { public: true })
    })
  }
  if (key === 'order') {
    router.push('/order').then(() => {
      trackerStore.reportBySpecialDirectives('Page_Jumpto', '我的订单', { public: true })
    })
  }
  if (key === 'changeAccount') {
    changeAccountModel.value = true
  }
  if (key === 'changeBackAccount') {
    changeBack()
  }
  showDropdown.value = false
}

const reload = inject('reload')
const useLocal = userInfo
async function changeAccountConfirm() {
  if (!accountVal.value)
    return
  const val: any = await switchAccounts({ targetUsername: accountVal.value.trim() })
  if (val.code === 1000) {
    window.$message.success('切换账号成功')
    Cookies.set('UserName', val.data)
    if (useLocal) {
      useLocal.username = val.data
      local.set('userInfo', useLocal)
    }
    trackerStore.addUserInfo(val.data)
    trackerStore.reportBySpecialDirectives('Account_Switch', '切换账号', { public: true })

    await getMembershipInformationFn()
    // appStore.reloadPage()
    tabStore.closeAllTabs()
    // 防止刷新当前页面导致数据报错
    setTimeout(() => {
      reload()
    }, 40)
  }
  accountVal.value = ''
  changeAccountModel.value = false
}
// 切回账号
async function changeBack() {
  const val: any = await switchAccountsBack()
  if (val.code === 1000) {
    Cookies.set('UserName', val.data)
    if (useLocal) {
      useLocal.username = val.data
      local.set('userInfo', useLocal)
    }
    trackerStore.addUserInfo(val.data)
    window.$message.success('切回账号成功')
    await getMembershipInformationFn()
    trackerStore.reportBySpecialDirectives('Account_Switch', '切回账号', { public: true })
    // appStore.reloadPage()
    tabStore.closeAllTabs()
    setTimeout(() => {
      reload()
    }, 40)
  }
}

const isMobile = ref(false)
function onClick() {
  if (isMobile.value) {
    showDropdown.value = !showDropdown.value // 点击切换显示状态
  }
  else {
    showDropdown.value = true // 非移动端点击时隐藏下拉菜单
  }
}

function onClickByPc() {
  if (!isMobile.value) {
    showDropdown.value = false// 点击切换显示状态
  }
}

function checkIsMobile() {
  const userAgent = navigator.userAgent.toLowerCase()
  isMobile.value = /mobile|android|iphone|ipad|phone/i.test(userAgent) || window.innerWidth < 768
}
function onMouseOver() {
  if (!isMobile.value) {
    showDropdown.value = true
  }
}
function onMouseLeave() {
  if (!isMobile.value) {
    showDropdown.value = false
  }
}
onMounted(() => {
  checkIsMobile()
  getMembershipInformationFn()
})

const themeOverrides: GlobalThemeOverrides = {
  Dropdown: {
    optionColorHover: '#1664FF',
    optionTextColorHover: '#fff',
  },
}
</script>

<template>
  <n-config-provider :theme-overrides="themeOverrides">
    <n-dropdown
      :show="showDropdown" :options="options" placement="bottom-end" @select="handleSelect"
      @mouseleave="onMouseLeave" @clickoutside="isMobile ? showDropdown = false : null"
    >
      <img
        class="w-34px mr-8px b-rd-50% " src="@/assets/images/avatar.png" alt="" @mouseover="onMouseOver"
        @click="onClick" @clickoutside="onClickByPc()"
      >
    </n-dropdown>
  </n-config-provider>
  <n-modal
    v-model:show="changeAccountModel" :mask-closable="false" class="max-w-400px" preset="card" title="账号切换"
    :bordered="false"
  >
    <div class="">
      <n-form-item
        :show-label="false" :rule="{
          required: accountVal.trim() === '' ? true : false,
          trigger: ['blur', 'input'],
          message: '请输入账号名',
        }"
      >
        <n-input v-model:value="accountVal" placeholder="请输入账号名" @keyup.enter="changeAccountConfirm();" />
      </n-form-item>
      <div class="flex mt-20px justify-center">
        <n-button class="mr-10px" color="#1664FF" @click="changeAccountConfirm">
          确定
        </n-button>
        <n-button @click="changeAccountModel = false; accountVal = ''">
          取消
        </n-button>
      </div>
    </div>
  </n-modal>
</template>

<style lang="scss" scoped></style>
